import { ListItem } from "../../ui_kit/ListItem";
import React, { useEffect, useState } from "react";
import styles from "./suggestion.module.scss";

interface SuggestionProps {
    onClick?: (data: any) => void;
    data: any[];
}

export const Suggestion: React.FC<SuggestionProps> = ({ onClick, data }) => {
    const [list, setList] = useState(data);

    useEffect(() => {
        setList(data);
    }, [data]);

    return (
        <ul className={styles.box}>
            <div
                className={styles.box__list}
                style={!list.length ? { height: "auto" } : { height: "18em" }}
            >
                {list.length > 0 ? (
                    list.map((item, l) => (
                        <li key={l}>
                            <span className={styles.box__list__span}>
                                {item.brand}
                            </span>
                            <ListItem
                                data={item.model}
                                item={item}
                                onClick={(data) =>
                                    onClick({
                                        brand: item.brand,
                                        model: data,
                                    })
                                }
                            />
                        </li>
                    ))
                ) : (
                    <li className={styles.box__item}>
                        Nenhum carro encontrado...
                    </li>
                )}
            </div>
        </ul>
    );
};
